<template>
  <div class="login_R_Form">
    <div class="login_R_FormItem flex_must">
      <div class="flex_must_1">单行文本</div>
      必填&nbsp;<a-switch size="small" v-model="options.require" />
    </div>
    <div class="login_R_FormItem">
      <div class="R_FormItem_name">组件名称</div>
      <div class="R_FormItem_data">
        <a-input v-model="options.label" placeholder="请输入" :maxLength='20'
          :suffix="options.label?options.label.length+'/20':'0/20'" />
      </div>
    </div>
    <div class="login_R_FormItem">
      <div class="R_FormItem_name">提示文字</div>
      <div class="R_FormItem_data">
        <a-input v-model="options.placeholder" placeholder="请输入" :maxLength='20'
          :suffix="options.placeholder?options.placeholder.length+'/20':'0/20'" />
      </div>
    </div>
    <div class="login_R_FormItem">
      <div @click="showModalFN" class="R_FormItem_name pointer">校验规则 <img class="tooltip_img" width="12px"
          src="@/assets/auto_img/information-circle@2x (1).png" alt="">
      </div>
      <div class="R_FormItem_data flex_box_zz">
        <span class="flex_box_name">正则规则</span>
        <a-input v-model="options.reg" placeholder="请输入" />
      </div>
      <div class="R_FormItem_data flex_box_zz">
        <span class="flex_box_name">错误提示</span>
        <a-input v-model="options.regMsg" placeholder="请输入" />
      </div>
    </div>
    <a-modal v-model="visible" title="常用规则" @ok="handleOkFN"> 
      <p>1. 校验数字 </p>
      <p>·整数： ^-?\d+$ (可以匹配正整数、负整数和零)</p>
      <p>·正整数：^[1-9]\d*$</p>
      <p>·负整数： ^-[1-9]\d*$</p>
      <p>·非负整数（正整数 + 0）： ^\d+$</p>
      <p>·非正整数（负整数 + 0）： ^((-\d+)|(0+))$</p>
      <p>2. 校验字符串 </p>
      <p>·英文字母： ^[A-Za-z]+$</p>
      <p>·大写英文字母： ^[A-Z]+$</p>
      <p>·小写英文字母： ^[a-z]+$</p>
      <p>·数字和英文字母： ^[A-Za-z0-9]+$</p>
      <p>·数字、英文字母和下划线： ^\w+$/ (等价于 ^[a-zA-Z_0-9]+$)</p>
      <p>·中文： ^[\u4e00-\u9fa5]+$</p>
      <p>·长度为n的字符串： ^.{n}$ (将 n 替换为所需的长度)</p>
      <p>·长度为n-m的字符串： ^.{n,m}$ (将 n 和 m 替换为所需的长度范围)</p>
      <p>3. 校验特殊格式 </p>
      <p>·Email地址： ^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$</p>
      <p>·域名： [a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\.?</p>
      <p>·URL： ^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$</p>
      <p>·手机号码： ^(13[0-9]|14[5,7]|15[0-9]|16[6]|17[0-8]|18[0-9]|19[8,9])\d{8}$ (中国大陆手机号码格式)</p>
      <p>·身份证号码： (^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)</p>
      <p>·IP地址： ((2(5[0-5]|[0-4]\d))|[01]?\d{1,2})(\.((2(5[0-5]|[0-4]\d))|[01]?\d{1,2})){3}</p>
      <p>·日期 (YYYY-MM-DD): ^\d{4}-\d{2}-\d{2}$</p>
      <p>·日期 (YYYY/MM/DD): ^\d{4}/\d{2}/\d{2}$</p>
      <p>·邮政编码： ^[1-9]\d{5}(?!\d)$</p>
      <p>4. 其他 </p>
      <p>·空白行： \n\s*\r (可以用来删除空白行)</p>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["checkTypeIndex"],
  data() {
    return {
      form: {},
      keyValue: 0,
      visible: false,
      regMsg: "<p>整数： ^-?\\d+$ (可以匹配正整数、负整数和零)</p>\n<p>正整数： ^[1-9]\\d*$</p>\n<p>负整数： ^-[1-9]\\d*$</p>\n<p>非负整数（正整数 + 0）： ^\\d+$</p>\n<p>非正整数（负整数 + 0）： ^((-\\d+)|(0+))$&nbsp;</p>\n<p>英文字母： ^[A-Za-z]+$</p>\n<p>大写英文字母： ^[A-Z]+$</p>\n<p>小写英文字母： ^[a-z]+$</p>\n<p>数字和英文字母： ^[A-Za-z0-9]+$&nbsp;</p>\n<p>中文： ^[\\u4e00-\\u9fa5]+$</p>\n<p>长度为n的字符串： ^.{n}$ (将 n 替换为所需的长度)</p>\n<p>长度为n-m的字符串： ^.{n,m}$ (将 n 和 m 替换为所需的长度范围)&nbsp;</p>\n<p>Email地址： ^\\w+([-+.]\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*$</p>\n<p>域名： [a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\\.?</p>\n<p>URL： ^(https?|ftp):\\/\\/[^\\s/$.?#].[^\\s]*$</p>\n<p>手机号码： ^(13[0-9]|14[5,7]|15[0-9]|16[6]|17[0-8]|18[0-9]|19[8,9])\\d{8}$ (常见的中国大陆手机号码格式，可能需要根据实际情况调整)</p>\n<p>身份证号码： (^\\d{15}$)|(^\\d{18}$)|(^\\d{17}(\\d|X|x)$)</p>\n<p>IP地址： ((2(5[0-5]|[0-4]\\d))|[01]?\\d{1,2})(\\.((2(5[0-5]|[0-4]\\d))|[01]?\\d{1,2})){3}</p>\n<p>日期 (YYYY-MM-DD): ^\\d{4}-\\d{2}-\\d{2}$</p>\n<p>日期 (YYYY/MM/DD): ^\\d{4}/\\d{2}/\\d{2}$&lt;</p>"
    };
  },
  computed: {
    ...mapGetters(["formwork"]),
    options() {
      return this.formwork[this.checkTypeIndex] ? this.formwork[this.checkTypeIndex].options : { options: this.formwork.inputOptions };
    },
  }, methods: {
    showModalFN() {
      this.visible = true;
    },
    handleOkFN(e) {
      console.log(e);
      this.visible = false;
    },
  }
};
</script>

<style lang="less" scoped>
.flex_box_zz {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  .flex_box_name {
    width: 80px;
    font-weight: 500;
    font-size: 12px;
    color: #828282;
    line-height: 17px;
    text-align: left;
    font-style: normal;
  }
}
.login_R_Form {
  margin: 10px 24px;
  border-top: 1px solid #eff0f2;
  padding-top: 20px;
  .login_R_FormItem {
    margin-bottom: 20px;
  }
  .R_FormItem_name {
    font-weight: 500;
    font-size: 12px;
    color: #222222;
    line-height: 17px;
    text-align: left;
    font-style: normal;
    margin-bottom: 12px;
  }
}
.flex_must {
  font-size: 14px;
  color: #222222;
  display: flex;
  align-items: center;
  .R_FormItem_name {
    flex: 1;
  }
}
.flex_must_1 {
  flex: 1;
}
</style> 